import { pegParse } from "./auth-service-tools1013.js";
import { SyntaxError } from "./auth-service-tools1013.js";
import { normalizeHashtagInPlural } from "./auth-service-tools1014.js";

function parse(input, opts) {
  var els = pegParse(input, opts);

  if (!opts || opts.normalizeHashtagInPlural !== false) {
    normalizeHashtagInPlural(els);
  }

  return els;
}

export { SyntaxError, parse, pegParse };